import { useState } from "react";
import { ChevronDown, Info } from "lucide-react";

const LABELS = {
  A: "A. MENGUMUMKAN INFORMASI PUBLIK WAJIB BERKALA",
  B: "B. MENYEDIAKAN DOKUMEN INFORMASI",
  C: "C. PENGEMBANGAN WEBSITE",
  D: "D. PENGADAAN BARANG DAN JASA",
  E: "E. KELEMBAGAAN",
};

export default function NilaiCard({ nilai }) {
  const [open, setOpen] = useState(false);
  if (!nilai) return null;
  return (
    <div
      data-testid="monev-nilai"
      className="rounded-3xl border border-[#E3EBF3] bg-white"
    >
      <button
        data-testid="monev-nilai-toggle"
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-3 px-6 py-5 text-left md:px-8"
      >
        <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
          Hasil Simulasi Penilaian
        </span>
        <span className="flex items-center gap-3">
          <span className="font-display text-xl font-semibold text-[#0B2440]">
            {nilai.total}{" "}
            <span className="text-xs font-medium text-slate-400">/ 100</span>
          </span>
          <ChevronDown
            aria-hidden="true"
            className={`h-5 w-5 text-slate-400 transition-transform duration-300 ${
              open ? "rotate-180" : ""
            }`}
          />
        </span>
      </button>

      {open && (
        <div className="border-t border-[#E3EBF3] px-6 py-6 md:px-8">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400">
              Bobot Monev (80%)
            </p>
            <p
              data-testid="monev-bobot"
              className="font-display text-2xl font-semibold text-[#1479BF]"
            >
              {nilai.bobot_monev}
            </p>
          </div>

          <div className="mt-4 space-y-3">
            {nilai.indikator.map((ind) => (
              <div key={ind.code} data-testid={`monev-nilai-row-${ind.code}`}>
                <div className="flex items-center justify-between gap-3">
                  <span className="text-[11px] font-bold text-[#0B2440]">
                    {LABELS[ind.code] || ind.title}
                  </span>
                  <span className="shrink-0 text-xs font-semibold text-slate-500">
                    {ind.skor} <span className="text-slate-300">/ {ind.max}</span>
                  </span>
                </div>
                <div className="mt-1.5 h-2 overflow-hidden rounded-full bg-[#EFF6FC]">
                  <div
                    data-testid={`monev-bar-${ind.code}`}
                    className="h-full rounded-full bg-[#1479BF] transition-all duration-500"
                    style={{ width: `${ind.persen}%` }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div
            data-testid="monev-disclaimer"
            className="mt-6 flex gap-3 rounded-2xl bg-[#EFF6FC] p-4"
          >
            <Info
              aria-hidden="true"
              className="mt-0.5 h-4 w-4 shrink-0 text-[#1479BF]"
            />
            <p className="text-[11px] leading-relaxed text-slate-500">
              {nilai.catatan}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
